<template>
    <div class="document-header">
        <div class="document-header-verified" v-if="isOrganizationVerified">
            <div class="document-header-data">
                <span class="document-header-data-title">{{$t('document.header.verified.title')}}</span>
                <span class="document-header-data-short-description" v-html="$t('document.header.verified.content', {organizationName: issuerProfileFullname})"></span>
            </div>
        </div>
        <div class="document-header-unverified" v-if="!isOrganizationVerified">
            <div class="document-header-data">
                <span class="document-header-data-title">{{$t('document.header.unverified.title')}}</span>
                <span class="document-header-data-short-description" v-html="$t('document.header.unverified.content', {organizationName: issuerProfileFullname})"></span>
            </div>
        </div>
        <div class="document-header-owner">
            <div class="document-header-picture" v-if="ownerProfilePictureUrl">
                <img :src="ownerProfilePictureUrl">
            </div>
            <div class="document-header-data">
                <span class="document-header-data-title">{{$t('document.header.owner.title')}}</span>
                <span class="document-header-data-fullname">{{ownerProfileFullname}}</span>
                <span class="document-header-data-short-description">{{ownerProfileShortDescription}}</span>
                <a target="_blank" :href="ownerProfileUrl" class="document-header-data-link">{{$t('document.header.owner.link')}}</a>
            </div>
        </div>
        <!-- <div class="document-header-issuer">
            <div class="document-header-picture" v-if="issuerProfilePictureUrl">
                <img :src="issuerProfilePictureUrl">
            </div>
            <div class="document-header-data">
                <span class="document-header-data-title">{{$t('document.header.issuer.title')}}</span>
                <span class="document-header-data-fullname">{{issuerProfileFullname}}</span>
                <span class="document-header-data-short-description">{{issuerProfileShortDescription}}</span>
                <a target="_blank" :href="issuerProfileUrl" class="document-header-data-link">{{$t('document.header.issuer.link')}}</a>
            </div>
        </div> -->
    </div>
</template>

<i18n>
{
    "en": {
        "document": {
            "header": {
                "verified": {
                    "title": "Congratulations!",
                    "content": "You opened a duly certified Smart Certificate document issued by <b>{organizationName}</b>. It's trustworthy and ensures the owner's integrity."
                },
                "unverified": {
                    "title": "This document is being checked",
                    "content": "The issuer of this document, <b>{organizationName}</b>, is being verified. Therefore, the authenticity and the validity of this document is not yet certified by Smart Certificate."
                },
                "owner": {
                    "title": "Document's owner",
                    "link": "View owner profile"
                },
                "issuer": {
                    "title": "Document's issuer",
                    "link": "View issuer profile"
                }
            }
        }
    },
    "es": {
        "document": {
            "header": {
                "verified": {
                    "title": "Enhorabuena.",
                    "content": "Ha abierto un documento de Smart Certificate debidamente certificado y emitido por <b>{organizationName}</b>. Es de confianza y garantiza la integridad del propietario."
                },
                "unverified": {
                    "title": "Este documento está siendo verificado",
                    "content": "El emisor de este documento, <b>{organizationName}</b>, está siendo verificado. Por lo tanto, la autenticidad y la validez de este documento aún no están certificadas por Smart Certificate."
                },
                "owner": {
                    "title": "Propietario del documento",
                    "link": "Ver perfil del propietario"
                },
                "issuer": {
                    "title": "Emisor del documento",
                    "link": "Ver perfil del emisor"
                }
            }
        }
    },
    "fr": {
        "document": {
            "header": {
                "verified": {
                    "title": "Félicitations !",
                    "content": "Vous avez ouvert un document Smart Certificate dûment certifié, émis par <b>{nom de l'organisation}</b>. Il est digne de confiance et garantit l'intégrité du propriétaire."
                },
                "unverified": {
                    "title": "Ce document est en cours de vérification",
                    "content": "L'émetteur de ce document, <b>{nom de l'organisation}</b>, est en cours de vérification. Par conséquent, l'authenticité et la validité de ce document ne sont pas encore certifiées par Smart Certificate."
                },
                "owner": {
                    "title": "Propriétaire du document",
                    "link": "Voir le profil du propriétaire"
                },
                "issuer": {
                    "title": "Émetteur du document",
                    "link": "Voir le profil de l'émetteur"
                }
            }
        }
    },
    "pt": {
        "document": {
            "header": {
                "verified": {
                    "title": "Parabéns!",
                    "content": "Abriu um documento Smart Certificate devidamente certificado emitido pela <b>{organizationName}</b>. É de confiança e garante a integridade do proprietário."
                },
                "unverified": {
                    "title": "Este documento está a ser verificado",
                    "content": "O emissor deste documento, <b>{organizationName}</b>, está a ser verificado. Por conseguinte, a autenticidade e a validade deste documento ainda não estão certificadas pelo Smart Certificate."
                },
                "owner": {
                    "title": "Proprietário do documento",
                    "link": "Ver perfil do proprietário"
                },
                "issuer": {
                    "title": "Emissor do documento",
                    "link": "Ver perfil do emitente"
                }
            }
        }
    },
    "de": {
        "document": {
            "header": {
                "verified": {
                    "title": "Herzlichen Glückwunsch!",
                    "content": "Sie haben ein ordnungsgemäß beglaubigtes Smart-Zertifikat geöffnet, das von <b>{Organisationsname}</b> ausgestellt wurde. Es ist vertrauenswürdig und gewährleistet die Integrität des Inhabers."
                },
                "unverified": {
                    "title": "Dieses Dokument wird gerade geprüft",
                    "content": "Der Aussteller dieses Dokuments, <b>{Organisationsname}</b>, wird derzeit überprüft. Daher ist die Authentizität und Gültigkeit dieses Dokuments noch nicht durch Smart Certificate zertifiziert."
                },
                "owner": {
                    "title": "Der Eigentümer des Dokuments",
                    "link": "Eigentümerprofil ansehen"
                },
                "issuer": {
                    "title": "Emittent des Dokuments",
                    "link": "Emittentenprofil ansehen"
                }
            }
        }
    },
    "nl": {
        "document": {
            "header": {
                "verified": {
                    "title": "Gefeliciteerd!",
                    "content": "U opende een naar behoren gecertificeerd Smart Certificate document uitgegeven door <b>{organisatienaam}</b>. Het is betrouwbaar en verzekert de integriteit van de eigenaar."
                },
                "unverified": {
                    "title": "Dit document wordt gecontroleerd",
                    "content": "De uitgever van dit document, <b>{organizationName}</b>, wordt geverifieerd. Daarom zijn de authenticiteit en de geldigheid van dit document nog niet gecertificeerd door Smart Certificate."
                },
                "owner": {
                    "title": "Eigenaar van het document",
                    "link": "Profiel van eigenaar bekijken"
                },
                "issuer": {
                    "title": "Uitgevende instelling van het document",
                    "link": "Bekijk het profiel van de emittent"
                }
            }
        }
    }
}
</i18n>

<script>
import { getModule } from '@/modules/store'
import ConfigStore from '@/modules/config/store/ConfigStore'

import { PublicDocument } from '@/modules/documents/models/PublicDocument'

export default {
    components: {
    },
    props: {
        publicDocument: {
            type: PublicDocument
        }
    },
    data() {
        return {
            isLoading: false,
            hidePictureIfEmpty: true
        }
    },
    computed: {
        configStore() {
            return getModule(ConfigStore)
        },
        ownerProfilePictureUrl() {
            return this.publicDocument.recipientPictureUrl ? this.$processUrl(this.publicDocument.recipientPictureUrl) : this.hidePictureIfEmpty ? '' : require('@/assets/v3/img/icons/user-dark.png')
            // return this.configStore.user.pictureUrl || this.hidePictureIfEmpty ? '' : require('@/assets/v3/img/icons/user-dark.png')
        },
        ownerProfileFullname() {
            return this.publicDocument.recipientName
            // return this.configStore.user.firstName + (this.configStore.user.lastName ? ' ' + this.configStore.user.lastName : '')
        },
        ownerProfileShortDescription() {
            return this.publicDocument.recipientShortDescription
            // return this.configStore.user.shortDescription
        },
        ownerProfileUrl() {
            return this.publicDocument.recipientPublicProfileUrl
        },
        issuerProfilePictureUrl() {
            return this.publicDocument.organizationLogo ? this.$processUrl(this.publicDocument.organizationLogo) : this.hidePictureIfEmpty ? '' : require('@/assets/v3/img/icons/user-dark.png')
            // return this.configStore.organizationPictureUrl || this.hidePictureIfEmpty ? '' : require('@/assets/v3/img/icons/user-dark.png')
        },
        issuerProfileFullname() {
            return this.publicDocument.organizationName
            // return this.configStore.organizationName
        },
        issuerProfileShortDescription() {
            return this.publicDocument.folderTitle
            // return this.configStore.folderName
        },
        issuerProfileUrl() {
            let url = this.publicDocument.organizationWebsiteUrl
            // make sure url is a full url starting with https
            if(url && !url.startsWith('https')) {
                url = 'https://' + url
            }
            return url
        },
        isOrganizationVerified() {
            return this.publicDocument.isVerified === true
        }
    },
    methods: {
    }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";
@import "./../css/public-document.styl";

.document-header
    display flex
    flex-direction row
    // gap 10px
    responsive-styling-auto-scale(gap, 10, $responsive-max-width)

    .document-header-verified
    .document-header-unverified
    .document-header-owner
    .document-header-issuer
        border-radius 5px
        background-color white
        display flex
        flex-direction row
        flex 1 1 auto
        width 50%
        justify-content flex-start
        align-items flex-start

    .document-header-picture
        flex 0 0 auto
        // width 140px
        // height 140px
        responsive-styling-auto-scale(width, 140, $responsive-max-width)
        responsive-styling-auto-scale(height, 140, $responsive-max-width)
        position relative
        // margin-right 12px
        // responsive-styling-auto-scale(margin-right, 12, $responsive-max-width)
        border-radius 5px 0 0 5px
        overflow hidden
        border-right #EBEBEB 1px solid

        img
            position absolute
            top 0
            left 0
            width 100%
            height 100%
            object-fit cover

    .document-header-data
        display flex
        flex-direction column
        justify-content flex-start
        box-sizing border-box
        min-height 100%
        // gap 4px
        responsive-styling-auto-scale(gap, 4, $responsive-max-width)
        responsive-styling-auto-scale(padding, 12, $responsive-max-width)

        div+&
            responsive-styling-auto-scale(padding-left, 24, $responsive-max-width)
            responsive-styling-auto-scale(padding-right, 24, $responsive-max-width)

        .document-header-data-title
            color #9F9F9F
            // font-size 16px
            responsive-styling-auto-scale(font-size, 16, $responsive-max-width)
            font-weight medium

        .document-header-data-fullname
            font-weight bold
            // font-size 24px
            responsive-styling-auto-scale(font-size, 24, $responsive-max-width)
            color black

        .document-header-data-short-description
            font-weight regular
            // font-size 18px
            responsive-styling-auto-scale(font-size, 18, $responsive-max-width)
            color black

        .document-header-data-link
            display flex
            align-items center
            responsive-styling-auto-scale(font-size, 16, $responsive-max-width)

            &::after
                margin-left 4px
                content "\e934"
                font-family: 'SmartCertificateV3' !important;
                speak: never;
                font-style: normal;
                font-weight: normal;
                font-variant: normal;
                text-transform: none;
                line-height: 1;

                /* Better Font Rendering =========== */
                -webkit-font-smoothing: antialiased;
                -moz-osx-font-smoothing: grayscale;

    .document-header-verified
        background-color #67c23a

        .document-header-data-title
            color rgba(255, 255, 255, 0.75)

        .document-header-data-short-description
            color white
            responsive-styling-auto-scale(font-size, 16, $responsive-max-width)

    .document-header-unverified
        background-color #FB5788

        .document-header-data-title
            color rgba(255, 255, 255, 0.75)

        .document-header-data-short-description
            color white
            responsive-styling-auto-scale(font-size, 16, $responsive-max-width)


    @media screen and (max-width: 846px)
        flex-direction column

        .document-header-owner
        .document-header-issuer
        .document-header-verified
        .document-header-unverified
            width 100%
</style>



// WEBPACK FOOTER //
// src/modules/documents/components/PublicDocumentHeader.vue